<!-- App.vue -->
<template>
  <WalletGuard>
    <router-view />
  </WalletGuard>
</template>

<script>
import WalletGuard from '@/components/WalletGuard.vue'

export default {
  name: 'App',
  components: {
    WalletGuard
  }
}
</script>
